import { useMutation } from 'react-query';

import { RefundDelete } from '../api';
import { RefundJournal } from '../mappers';

const useRefundDelete = () => {
  return useMutation({
    mutationFn: async ({ id }: { id: number }) => {
      const { data } = await RefundDelete({ id });

      const item = RefundJournal(data);

      return { item };
    }
  });
};

export default useRefundDelete;
